import { P00039DataRxTxIndex } from '../../../P00039Sync';

import { P00032 } from '../../../P00032';
import { getPoolMasterClass } from '../../../../../ECoSystemsHelper';
import { P0003600 } from '../../../P0003600';
import { P0004700 } from '../../../P0004700';
import { P00046 } from '../../../P00046';
import { IProduct } from '../../../../IProduct';
import { P0003601 } from '../../../P0003601';
import { P00058 } from '../../../P00058';
import { P0006600 } from '../../../P0006600';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';

export function P00080AltimeoMiseEnOeuvreInit(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
  getValue: any,
  additionalData: PoolAdditionalData,
) {
  return false;
}
